import SearchTableQuery from '../store/schema/SearchTableQuery';
import { OwaDate } from 'owa-datetime';
import { TableQuery, TableQueryType } from 'owa-mail-list-store';
import { ObservableMap } from 'mobx';
import { PillSuggestion, SearchScope } from 'owa-search-service';
import ReactListViewType from 'owa-service/lib/contract/ReactListViewType';

/**
 * Creates the table query for search table.
 */
export default function createMailSearchTableQuery(
    searchNumber: number,
    queryString: string,
    searchScope: SearchScope,
    selectedPillSuggestions: ObservableMap<string, PillSuggestion>,
    listViewType: ReactListViewType,
    includeAttachments: boolean,
    fromDate: OwaDate,
    toDate: OwaDate
): TableQuery {
    const pillSuggestions = [...selectedPillSuggestions.values()];

    const searchTableQuery: SearchTableQuery = {
        folderId: null,
        type: TableQueryType.Search,
        listViewType: listViewType,
        searchNumber: searchNumber,
        queryString: queryString,
        searchScope: searchScope,
        pillSuggestions: pillSuggestions,
        includeAttachments: includeAttachments,
        fromDate: fromDate,
        toDate: toDate,
        scenarioType: 'mail',
    };

    return searchTableQuery;
}
